export default function IconDistance() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M12 3C14.485 3 16.735 4.0075 18.3638 5.63624C19.9925 7.26497 21 9.51497 21 12C21 14.4851 19.9925 16.7351 18.3638 18.3638C16.735 19.9925 14.485 21 12 21C9.51495 21 7.26497 19.9925 5.63623 18.3638C4.0075 16.7351 3 14.4851 3 12C3 9.51497 4.0075 7.26497 5.63623 5.63624C7.26497 4.0075 9.51495 3 12 3Z"
                stroke="#707070"
            />
            <path d="M12 7V13L15.5 11" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
